export default "__VITE_ASSET__9$xhS9BY__"